import { z } from 'zod';

/**
 * ツリーグリッド編集画面（TargetNodeTreeEditor）の「展開モード」フィルタタブ。
 *
 * - target: **行の剪定**。アンカー（スコープ / 紐付け）ノード + その祖先のみを
 *   全展開表示する（閲覧タブと同じ見え方。selectEditorDisplayTree）
 * - subModule: **root 直下ブランチの剪定 + 展開制御**。アンカーを 1 つも
 *   含まないモジュール（root 直下の子）を行ごと非表示にし、残存ブランチは
 *   全行表示のまま target 相当の最小展開 ∪ 各アンカーの最寄り SUB_MODULE
 *   祖先のサブツリーを展開する
 * - module: 全行表示。subModule 相当の展開 ∪ 各アンカーの最寄り MODULE
 *   祖先のサブツリー全展開
 * - all: 全行表示・全展開
 *
 * 段階的開示（情報量順）: target ⊂ subModule ⊂ module ⊂ all。
 */
export const ExpandModeSchema = z.enum(['target', 'subModule', 'module', 'all']);
export type ExpandMode = z.infer<typeof ExpandModeSchema>;

/**
 * TargetNodeTreeEditor を使う編集画面の URL search 共通スキーマ。
 * expandMode は展開モードタブ、q はノード名の部分一致検索文字列。
 * 顧客の利用機能編集 / プロダクトスコープ編集の両ルートが validateSearch に使う。
 */
export const TargetNodeTreeEditorSearchSchema = z.object({
  expandMode: ExpandModeSchema.catch('target').default('target'),
  q: z.string().optional()
});